/**
 * 服务端响应代码
 */

/**
 * 成功
 */
export const OK = '00000'

/**
 * 客户端错误前缀
 */
export const PREFIX_CLIENT_ERROR = 'C'

/**
 * 客户端错误
 */
export const CLIENT_ERROR = 'C0000'

/**
 * 访问未授权
 */
export const UNAUTHORIZED = 'C0301'

/**
 * 参数错误
 */
export const INVALID_PARAM = 'C0400'

/**
 * 服务端错误前缀
 */
export const PREFIX_SERVER_ERROR = 'S'

/**
 * 服务端错误
 */
export const SERVER_ERROR = 'S0000'

/**
 * 业务异常前缀
 */
export const PREFIX_BUSINESS_ERROR = 'B'

/**
 * 业务异常
 */
export const BUSINESS_ERROR = 'B0000'
